const OPTIONS = [
  { key: "paystack", label: "Paystack", note: "Card" },
  { key: "payfast", label: "PayFast", note: "Card, Instant EFT & more" },
];

export const ProviderPicker = ({ providers, value, onChange }) => (
  <div data-testid="payment-provider-picker" className="grid grid-cols-2 gap-2">
    {OPTIONS.map((o) => {
      const ready = providers?.[o.key];
      return (
        <button
          key={o.key}
          type="button"
          data-testid={`provider-${o.key}`}
          aria-pressed={value === o.key}
          onClick={() => onChange(o.key)}
          className={`what-provider ${value === o.key ? "is-on" : ""}`}
        >
          <span className="text-sm font-semibold text-white">{o.label}</span>
          <span className={`text-[11px] ${ready ? "text-slate-400" : "text-amber-300/80"}`}>{ready ? o.note : "not set up yet"}</span>
        </button>
      );
    })}
  </div>
);

export const pickDefaultProvider = (providers) => (providers?.paystack || !providers?.payfast ? "paystack" : "payfast");
